import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field, Form } from 'redux-form';

import { Button, renderDropdownList } from '../../../helpers';

function AttachSubGroupForm({ items, errorMessage, handleSubmit, onClose, onSubmit }) {
  return (
    <Form onSubmit={handleSubmit(values => onSubmit(values))}>
      <div className="row">
        <div className="col-12">
          <Field name="ring_group_tag" label="Select Subgroup" component={renderDropdownList} data={items} />
        </div>
      </div>

      {errorMessage ? <div className="alert alert-danger">{errorMessage}</div> : null}

      <div className="btn-group">
        <Button color="secondary" onClick={() => onClose()}>
          Close
        </Button>
        <Button submit color="success">
          Attach
        </Button>
      </div>
    </Form>
  );
}

AttachSubGroupForm.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  errorMessage: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

AttachSubGroupForm.defaultProps = {
  errorMessage: null
};

function validate({ ring_group_tag: ringGroupTag }) {
  const errors = {};

  if (!ringGroupTag) {
    errors.ring_group_tag = 'Please, select at least one subgroup';
  }

  return errors;
}

export default reduxForm({ form: 'attach-subgroup-to-ringgroup', validate })(AttachSubGroupForm);
